export const FINANCIAL_METRIC_KEYS = [
  'investment',
  'projectedClients',
  'projectedRevenue',
  'cpl',
  'cac',
  'roas',
  'roi',
] as const;
export type FinancialMetricKey = (typeof FINANCIAL_METRIC_KEYS)[number];

export type FinancialMetricUnit = 'money' | 'count' | 'ratio';

export const FINANCIAL_METRIC_UNITS: Record<FinancialMetricKey, FinancialMetricUnit> = {
  investment: 'money',
  projectedClients: 'count',
  projectedRevenue: 'money',
  cpl: 'money',
  cac: 'money',
  roas: 'ratio',
  roi: 'ratio',
};

export type FinancialMetricState = 'known' | 'unknown' | 'invalid' | 'not_applicable' | 'partial';

/**
 * SPEC-009 DF-158/§85-90 — a lean projection of SPEC-008 outputs, never a
 * new formula. `baseValue`/`scenarioValue` are read straight from
 * `FunnelAggregateResult`; this module only compares and formats.
 */
export interface FinancialMetricComparison {
  metric: FinancialMetricKey;
  unit: FinancialMetricUnit;
  baseValue: number | null;
  scenarioValue: number | null;
  delta: number | null;
  state: FinancialMetricState;
}

export interface FinancialScenarioView {
  scenarioId?: string;
  scenarioName: string;
  metrics: FinancialMetricComparison[];
  /** Pass-through of the SPEC-008 funnel warnings for this scenario's run — no new codes are minted here. */
  warnings: import('@/domain/metrics/contracts').MetricWarning[];
}
